import zappy from "@zappy-ride/library.react.components";
import { OutputTabs } from "./Tabs";

export * from "./Tabs";

zappy.FactoryInstance.registerComponent(OutputTabs);
